






















































































































import { Component, Vue, Prop } from "vue-property-decorator";
import MainHeader from "../../main/components/main-header/main-header.vue";
import NavLeft from "../components/nav-left.vue";
@Component({
  components: {
    MainHeader,
    NavLeft,
  },
})
export default class Jsgl extends Vue {
  private roles: any[] = [
    {
      角色名称: "项目负责人",
      录入数据: true,
      数据查看: true,
      数据导出: true,
      质疑: false,
      审核通过: false,
      监查痕迹: true,
      账户管理: true,
      组织架构: true,
      邀请码管理: true,
      数据权限管理: true,
      分析挖掘: true,
      项目报告: true,
      角色描述: "负责管理整个项目。",
    },
    {
      角色名称: "课题负责人",
      录入数据: true,
      数据查看: true,
      数据导出: true,
      质疑: false,
      审核通过: false,
      监查痕迹: true,
      账户管理: true,
      组织架构: true,
      邀请码管理: true,
      数据权限管理: true,
      分析挖掘: true,
      项目报告: true,
      角色描述: "负责管理整个专病课题组。",
    },
    {
      角色名称: "监查员",
      录入数据: false,
      数据查看: true,
      数据导出: false,
      质疑: true,
      审核通过: true,
      监查痕迹: true,
      账户管理: false,
      组织架构: false,
      邀请码管理: false,
      数据权限管理: false,
      分析挖掘: false,
      项目报告: true,
      角色描述:
        "负责监查专病课题组下数据的逻辑性。",
    },
    {
      角色名称: "分中心负责人",
      录入数据: true,
      数据查看: true,
      数据导出: false,
      质疑: false,
      审核通过: false,
      监查痕迹: true,
      账户管理: true,
      组织架构: true,
      邀请码管理: true,
      数据权限管理: false,
      分析挖掘: true,
      项目报告: true,
      角色描述: "负责管理整个分中心。",
    },
    {
      角色名称: "质量审核员",
      录入数据: false,
      数据查看: true,
      数据导出: false,
      质疑: true,
      审核通过: true,
      监查痕迹: false,
      账户管理: false,
      组织架构: false,
      邀请码管理: false,
      数据权限管理: false,
      分析挖掘: false,
      项目报告: true,
      角色描述:
        "负责检查分中心下数据的完整性。",
    },
    {
      角色名称: "主要研究者",
      录入数据: true,
      数据查看: true,
      数据导出: false,
      质疑: false,
      审核通过: false,
      监查痕迹: false,
      账户管理: true,
      组织架构: false,
      邀请码管理: false,
      数据权限管理: false,
      分析挖掘: false,
      项目报告: true,
      角色描述: "负责管理研究小组和数据采集录入。",
    },
    {
      角色名称: "研究者",
      录入数据: true,
      数据查看: true,
      数据导出: false,
      质疑: false,
      审核通过: false,
      监查痕迹: false,
      账户管理: false,
      组织架构: false,
      邀请码管理: false,
      数据权限管理: false,
      分析挖掘: false,
      项目报告: true,
      角色描述: "负责数据采集录入。",
    },
  ];
}
